module.exports = __webpack_public_path__ + "img/error.e83007b1.svg";